export default "__VITE_ASSET__DzGmPQuW__"